import ScrollUpArrow from "@/components/Common/ScrollUpArrow";
import IndiividualInsightsFirstSection from "@/components/Insights/IndiividualInsightsFirstSection";
import InsightsList from "@/components/Insights/InsightsList";
import MetaTags from "@/components/seo/meta-tags";
import React from "react";
import { BreadcrumbJsonLd } from "next-seo";

const SingleEvents = ({ data }) => {
  const event = data?.Data?.results[0];
  const similarEvents = data?.RelatedEventData;
  return (
    <>
      <MetaTags
        title={event?.metaTitle}
        description={event?.metaDescription}
        image={event?.metaImage || null}
      />
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: "Home",
            item: `${process.env.NEXT_PUBLIC_APP_URL}/`,
          },
          {
            position: 2,
            name: "Events",
            item: `${process.env.NEXT_PUBLIC_APP_URL}/events`,
          },
          {
            position: 3,
            name: event?.title,
            item: `${process.env.NEXT_PUBLIC_APP_URL}/events/${event?.slug}-${event?.id}`,
          },
        ]}
      />
      <div className="min-h-[100vh] min-w-full">
        <ScrollUpArrow />
        <IndiividualInsightsFirstSection data={event} page={"Our Events"} />
        {similarEvents?.length > 0 && (
          <InsightsList
            data={similarEvents}
            page={"Similar Events"}
            type={"events"}
            isSimilar={true}
          />
        )}
      </div>
    </>
  );
};

export default SingleEvents;

export async function getServerSideProps(context) {
  const { query } = context;
  const id = query.singleEvents.slice(query.singleEvents.lastIndexOf("-") + 1);
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_URL}/events/?id=${id}`
  );
  const data = await res.json();
  if (!data) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      data: data,
    },
  };
}
